import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Grid,
  InputLabel,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import {
  getOnBoardCompliance,
  postAddOnBoardCompliance,
} from 'redux/actions/UserCompliance';
import { toast } from 'react-toastify';
import { truncateComment ,getDateFormat} from 'utils/utils';
import { complianceExpiryMaxDate,imageSize } from 'utils/enumObj';
import closebtn from 'assets/images/CrossBtn.svg';
import warning from 'assets/images/Warning.svg';
import greenCheck from 'assets/images/CheckSquare.svg';
import { postReuploadCompliance } from 'services/ComplianceReuploadService';

function ComplianceUpload(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const minDate = getDateFormat(new Date(),'onboardingDateFormat');
  const [image, setImage] = useState(null);
  const [close, setclose] = useState(true);
  const [formValidation, setFormValidation] = useState({});
 
const reduxComplianceData = useSelector(
  (state) => state.userOnBoardCompliance?.userOnBoardCompliance
);

const onBoardComplianceData = {
  ...reduxComplianceData,
  data: props?.details?.length > 0
    ? props.details
    : reduxComplianceData?.data || []
};
  const vehicledata = useSelector(
    (state) => state.userAddVehicle?.userAddVehicle.data
  );
  const rejectedData = onBoardComplianceData?.data?.filter(
    (val, idx) => val?.complianceValue?.[0]?.status === 'Rejected'
  );
  const UploadedData = onBoardComplianceData?.data?.filter(
    (val, idx) => val?.complianceValue?.[0]?.status === 'Uploaded'
  );
  const ExpiredData = onBoardComplianceData?.data?.filter(
    (val, idx) => val?.complianceValue?.[0]?.isExpired === true
  );
  const addOnBoardCompliance = useSelector(
    (state) =>
      state?.userAddOnBoardCompliance?.userAddOnBoardCompliance?.success
  );

  const [licenseNumberEdited, setLicenseNumberEdited] = useState(false);
  const [formDataIntialise, setFormDataIntialise] = useState([
    { licenseNumber: '', expiryDate: '', imageName: null },
  ]);
  const [fileSizeError, setFileSizeError] = useState(
    Array(formDataIntialise.length).fill(false)
  );
  const [fileTypeError, setFileTypeError] = useState(
    Array(formDataIntialise.length).fill(false)
  );

  const complianceData = onBoardComplianceData?.data || [];

  const isSoonToExpire = (expiryDate) => {
    if (!expiryDate) return false;
    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    const timeDifference = expiry.getTime() - currentDate.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
    return daysDifference > 0 && daysDifference <= 30;
  };

  // Check if all mandatory items have 'Approved' status
  const allMandatoryApproved = complianceData
    .filter((item) => item.isMandatory) // Filter only mandatory items
    .every((item) => item.complianceValue?.[0]?.status === 'Approved');

  useEffect(() => {
    if (props?.tabName !== 'vehicle' && props?.tabName !== 'driver') {
      dispatch(getOnBoardCompliance());
    }
    const statusCompliance = localStorage.getItem('status');
    if (
      statusCompliance === 'Active' &&
      props?.tabName === 'Self' &&
      props?.tabName !== 'vehicle'
    ) {
      navigate('/dashboard');
    }
  }, []);

  const fileSize = (file) => {
    const sizeInBytes = file.size;
    return sizeInBytes;
  };

  const handleFileChange = (event, idx) => {
    setFileSizeError('');
    setFileTypeError('');
    if (event.target.files && event.target.files.length > 0) {
      setLicenseNumberEdited(true);
      const files = event.target.files; // Get the array of selected files
      const attributeType = onBoardComplianceData?.data[idx]?.attributeType;

      const allowedFileTypesForAttributeType =
        attributeType === 'File'
          ? ['image/jpeg', 'image/png', 'application/pdf']
          : ['image/jpeg', 'image/png'];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!allowedFileTypesForAttributeType.includes(file.type)) {
          // Check if the file type is not allowed
          setFileTypeError((prevErrors) => {
            const updatedErrors = [...prevErrors];
            updatedErrors[idx] = true;
            return updatedErrors;
          });
          // Clear the imageName when a file type error occurs
          setFormDataIntialise((prevFormData) => {
            const updatedFormData = [...prevFormData];
            updatedFormData[idx] = { ...updatedFormData[idx], imageName: ' ' };
            return updatedFormData;
          });

          return;
        }

        if (fileSize(file) > imageSize.fileSize) {
          setFileSizeError((prevErrors) => {
            const updatedErrors = [...prevErrors];
            updatedErrors[idx] = true;
            return updatedErrors;
          });
          setFormDataIntialise((prevFormData) => {
            const updatedFormData = [...prevFormData];
            updatedFormData[idx] = { ...updatedFormData[idx], imageName: ' ' };
            return updatedFormData;
          });

          return;
        }
      }

      setFormDataIntialise((prevFormData) => {
        const updatedFormData = [...prevFormData];
        const imageNames = [];
        for (let i = 0; i < files.length; i++) {
          imageNames.push(files[i].name);
        }
        updatedFormData[idx] = {
          ...updatedFormData[idx],
          imageName: imageNames.join(', '),
        };
        return updatedFormData;
      });

      // For handling only one file in 'File' attribute type
      if (
        onBoardComplianceData?.data[idx]?.attributeType === 'File' &&
        files.length === 1
      ) {
        setImage(files[0]); // Store the selected file
      } else {
        setImage(files);
      }
    }
  };

  const complainceClick = async (attributeId, idx) => {
    const filteredData = formDataIntialise[idx];

    // Create a new FormData instance
    const formDataDetail = new FormData();
    if (onBoardComplianceData?.data[idx]?.attributeType === 'File') {
      formDataDetail.append('complianceFile', image || '');
    } else if (onBoardComplianceData?.data[idx]?.attributeType === 'Image') {
      formDataDetail.append('complianceFile', image[0] || '');
    } else if (
      onBoardComplianceData?.data[idx]?.attributeType === 'Multi-Image'
    ) {
      for (let i = 0; i < image?.length; i++) {
        formDataDetail.append('complianceFile', image[i] || '');
      }
    }
    if (props?.reupload) {
    formDataDetail.append('complianceValueId', attributeId);
  }
  else {
    formDataDetail.append('complianceAttributeId', attributeId);
  }

    if (!filteredData?.licenseNumber) {
      const attributeValue =
        onBoardComplianceData?.data[idx]?.complianceValue?.[0]?.atributeValue ||
        '';
      formDataDetail.append('complianceValue', attributeValue);
    } else {
      formDataDetail.append('complianceValue', filteredData?.licenseNumber);
    }

    let selectedVehicleId = '';
    if (props?.tabName === 'vehicle') {
      selectedVehicleId = props?.vehicleId || vehicledata[0]?.vehicleId;
    }
    if (selectedVehicleId) {
      formDataDetail.append('vehicleId', selectedVehicleId);
    }
    if (props?.tabName === 'driver'){
      formDataDetail.append('driverId', props?.driverId);
    }
    if (onBoardComplianceData?.data?.[idx]?.isExpiring === true) {
      if (!filteredData?.expiryDate) {
        const expiryValue =
          onBoardComplianceData?.data[idx]?.complianceValue?.[0]?.expiryDate ||
          '';
        formDataDetail.append('expiryDate', expiryValue);
      } else {
        formDataDetail.append('expiryDate', filteredData?.expiryDate);
      }
    }
    try {
      if (props?.reupload) {
        const reuploadResponse = await postReuploadCompliance(formDataDetail);

        setImage(null);

        if (reuploadResponse?.success) {
          toast.success(
            reuploadResponse?.message ||
              'Compliance document reuploaded successfully'
          );
          props?.onSuccess?.();
        } else {
          toast.error(
            reuploadResponse?.message || 'Reupload compliance failed'
          );
        }
      } else {
        const response = await dispatch(postAddOnBoardCompliance(formDataDetail));

        if (response?.payload?.success && props?.onSuccess) {
          props.onSuccess();
        }
      }

    } catch (err) {
      console.error("Error in compliance upload:", err);
      if (props?.reupload) {
        toast.error(
          err?.response?.data?.message || 'Reupload compliance failed'
        );
      }
    }
  };

  const handleInput = (e, idx, element) => {
    const { name, value } = e.target;
    if (name === 'licenseNumber') {
      setLicenseNumberEdited(true);
    }

    setFormDataIntialise((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[idx] = { ...updatedFormData[idx], [name]: value};
      return updatedFormData;
    });

    if(element?.ComplianceValidation?.id) {
      const regexTemplate = new RegExp(element?.ComplianceValidation?.value) 
      let errorData = ""

      if(e.target.value) {
        if(!regexTemplate.exec(e.target?.value?.toUpperCase())) {
          errorData = {...formValidation, [element?.attributeName]: true, [`${element?.attributeName}-msg`]: element?.ComplianceValidation?.description}
        }
        else {
          errorData = {...formValidation, [element?.attributeName]: false}
       }
      }
      else {
        errorData = {...formValidation, [element?.attributeName]: false}
     }   
      setFormValidation(errorData);
    }

  };

  const isInputEmpty = (idx, formFieldError, element) => {
    
    const formData = formDataIntialise[idx];
    const imageType = element?.attributeType === "text" ? true : formData?.imageName;
    const expiryType = element?.isExpiring ? formData?.expiryDate : true;    

    if(formData?.licenseNumber && imageType && expiryType && !formFieldError) {
      return false
    }
    else {
      return true
    }
  };
  
  const handleclose = () => {
    setclose(false);
  };

  // ---Condition for Image---
  let statusIcon = '';
  switch (onBoardComplianceData?.data?.complianceValue?.[0]?.status) {
    case 'Rejected':
      statusIcon = <img src={warning} alt="rejected" className="width20 mr6" />;
      break;
    case 'Approved':
      statusIcon = (
        <img src={greenCheck} alt="approved" className="width20 mr6" />
      );
      break;
    default:
      statusIcon = '';
  }

  return (
    <div>
      <Grid container md={12} className="flexColumn mtb10">
        {!props?.reupload && close && (rejectedData?.length > 0 || ExpiredData?.length > 0) && (
          <Grid container className="backgroundRejected justifyBetween flexRow">
            <Grid item xs={10}>
              {rejectedData?.map((val) => (
                <ul className="colorDarkRed mtb30" key={val.id}>
                  <li>
                    {val.attributeName +
                      ': ' +
                      val?.complianceValue?.[0]?.rejectionReason}
                  </li>
                </ul>
              ))}
              {ExpiredData?.map((val) => (
                <ul className="colorDarkRed mtb30" key={val.id}>
                  <li>{val.attributeName + ': ' + 'Expired'}</li>
                </ul>
              ))}
            </Grid>
            <Grid item xs={1} className="flexend">
              <img
                src={closebtn}
                alt="close"
                onClick={handleclose}
                className="cursor p10"
              />
            </Grid>
          </Grid>
        )}

      {!props?.reupload &&
        <Grid item>
          {allMandatoryApproved ? (
            <Typography
              variant={'body1'}
              className={`fw400 colorGreen ${
                props?.tabName === 'Self' ? 'mb30' : ' mtb30'
              } `}
            >
              Your document verified
            </Typography>
          ) : UploadedData?.length > 0 ? (
            <Typography
              variant={'body1'}
              className={`fw400 colorYellow ${
                props?.tabName === 'Self' ? 'mb30' : ' mtb30'
              } `}
            >
              Your document is under verifications
            </Typography>
          ) : (
            <Typography
              variant={'body1'}
              className={`fw400 colorGrey ${
                props?.tabName === 'Self' ? 'mb30' : ' mtb30'
              } `}
            >
              You need to upload your document as given below for the verification
            </Typography>
          )}
        </Grid>
      }
        {onBoardComplianceData?.data?.map((ele, idx) => (
          <Grid
            item
            container
            md={12}
            key={idx}
            direction='column'
            className='complianceUploadModal'
          >
            <Grid
              item
              className={`complianceColor width100 ${ele?.complianceValue?.[0]?.status === 'Rejected'
                  ? 'borderRed'
                  : ''
                }`}
            >
              <Typography
                variant="body1"
                className="colorPrimary pb10 flexStart"
              >
                {statusIcon}
                {ele?.attributeName}
                {ele?.isMandatory && <span className="colorRed">*</span>}
              </Typography>
              <Grid
                item
                container
                direction="row"
                justifyContent='space-between'
                alignItems="flex-end"
              >
                {ele?.attributeType === 'File' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue?.[0]?.complianceFile?.name ||
                      ele?.complianceValue?.[0]?.status === 'Rejected' ||
                      ele?.complianceValue?.[0]?.isExpired === true || isSoonToExpire(ele?.complianceValue?.[0]?.expiryDate)) && (
                        <Button
                          variant="contained"
                          component="label"
                          className="uploadBtnCompliance"
                        >
                          <Typography>Upload File </Typography>{' '}
                          <FileUploadOutlinedIcon />
                          <input
                            type="file"
                            hidden
                            accept="image/jpeg, image/png, application/pdf"
                            onChange={(event) => handleFileChange(event, idx)}
                          />
                        </Button>
                      )}
                    {formDataIntialise[idx]?.imageName &&
                      formDataIntialise[idx]?.imageName !== null ? (
                      <Typography
                        className={
                          !ele?.complianceValue?.[0]?.complianceFile?.name ||
                            ele?.complianceValue?.[0]?.status === 'Rejected'
                            ? 'font14'
                            : 'font16'
                        }
                      >
                        <Tooltip
                          title={formDataIntialise[idx].imageName}
                          placement="bottom"
                        >
                          {truncateComment(
                            formDataIntialise[idx].imageName,
                            20
                          )}
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Typography>
                        {ele?.complianceValue?.length > 0 &&
                          ele.complianceValue?.[0]?.complianceFile?.name ? (
                          <Tooltip
                            title={
                              ele.complianceValue?.[0].complianceFile.name
                            }
                            placement="bottom"
                          >
                            {truncateComment(
                              ele.complianceValue?.[0].complianceFile.name,
                              15
                            )}
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Typography>
                    )}
                    {fileSizeError[idx] && (
                      <Typography className="colorRed">
                        File size should not exceed 1 MB
                      </Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">
                        selected File Type Not Allowed
                      </Typography>
                    )}
                  </Grid>
                ) : null}
                {ele?.attributeType === 'Image' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue?.[0]?.complianceFile?.name ||
                      ele?.complianceValue?.[0]?.status === 'Rejected' ||
                      ele?.complianceValue?.[0]?.isExpired === true) && (
                        <Button
                          variant="contained"
                          component="label"
                          className="uploadBtnCompliance"
                        >
                          <Typography>Upload File </Typography>{' '}
                          <FileUploadOutlinedIcon />
                          <input
                            type="file"
                            hidden
                            accept="image/jpeg, image/png"
                            onChange={(event) => handleFileChange(event, idx)}
                          />
                        </Button>
                      )}
                    {formDataIntialise[idx]?.imageName &&
                      formDataIntialise[idx]?.imageName !== null ? (
                      <Typography className="font14">
                        <Tooltip
                          title={formDataIntialise[idx].imageName}
                          placement="bottom"
                        >
                          {truncateComment(
                            formDataIntialise[idx].imageName,
                            20
                          )}
                        </Tooltip>{' '}
                      </Typography>
                    ) : (
                      <Typography>
                        {ele?.complianceValue?.length > 0 &&
                          ele.complianceValue?.[0]?.complianceFile?.name ? (
                          <Tooltip
                            title={
                              ele.complianceValue?.[0]?.complianceFile?.name
                            }
                            placement="bottom"
                          >
                            {truncateComment(
                              ele.complianceValue?.[0]?.complianceFile?.name,
                              25
                            )}
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Typography>
                    )}
                    {fileSizeError[idx] && (
                      <Typography className="colorRed">
                        File size should not exceed 1 MB
                      </Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">
                        selected File Type Not Allowed
                      </Typography>
                    )}
                  </Grid>
                ) : ele?.attributeType === 'Multi-Image' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue?.[0]?.complianceFile?.name ||
                      ele?.complianceValue?.[0]?.status === 'Rejected' ||
                      ele?.complianceValue?.[0]?.isExpired === true) && (
                        <Button
                          variant="contained"
                          component="label"
                          className="uploadBtnCompliance"
                        >
                          <Typography>Upload File </Typography>{' '}
                          <FileUploadOutlinedIcon />
                          <input
                            type="file"
                            hidden
                            accept="image/jpeg, image/png"
                            multiple
                            onChange={(event) => handleFileChange(event, idx)}
                          />
                        </Button>

                      )}
                    {formDataIntialise[idx]?.imageName &&
                      formDataIntialise[idx]?.imageName !== null ? (
                      <Typography className="font14">
                        <Tooltip
                          title={formDataIntialise[idx].imageName}
                          placement="bottom"
                        >
                          {truncateComment(
                            formDataIntialise[idx].imageName,
                            20
                          )}
                        </Tooltip>{' '}
                      </Typography>
                    ) : (
                      <Typography>
                        {ele?.complianceValue?.length > 0 &&
                          ele.complianceValue?.[0]?.complianceFile?.name ? (
                          <Tooltip
                            title={
                              ele.complianceValue?.[0]?.complianceFile?.name
                            }
                            placement="bottom"
                          >
                            {truncateComment(
                              ele.complianceValue?.[0]?.complianceFile?.name,
                              25
                            )}
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Typography>

                    )}
                    {fileSizeError[idx] && (
                      <Typography className="colorRed">
                        File size should not exceed 1 MB
                      </Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">
                        selected File Type Not Allowed
                      </Typography>
                    )}
                  </Grid>
                ) : null}
                <Grid item md={12} className='mrb10'>
                  <InputLabel className='formLabel' htmlFor="expiry-date-input">
                    {ele?.attributeType === 'File' && ele?.attributeName
                      ? ele?.attributeName
                      : ele?.attributeName}
                  </InputLabel>
                  <TextField
                    className="mt10 width100 bgWhite licenseTextField"
                    size="small"
                    type="text"
                    value={
                      formDataIntialise[idx]?.licenseNumber ||
                      ele.complianceValue?.[0]?.atributeValue ||
                      ''
                    }
                    name="licenseNumber"
                    onChange={(event) => handleInput(event, idx, ele)}
disabled={
  props?.reupload
    ? false
    : ((ele?.complianceValue?.[0]?.isExpired === true || isSoonToExpire(ele?.complianceValue?.[0]?.expiryDate)) && props.fromSubVendorExpiry) ||
      (ele?.complianceValue?.[0]?.status !== 'Approved' &&
        ele?.complianceValue?.[0]?.status !== 'Uploaded')
      ? false
      : true
}
                    placeholder={`Enter ${ele?.attributeName}`}
                  />
                  {formValidation?.[ele?.attributeName] && <Typography className='errorMessage'>{formValidation?.[`${ele?.attributeName}-msg`]}</Typography>}
                </Grid>
                {ele?.isExpiring === true && (
                  <Grid item md={12} className='mrb10'>
                    <InputLabel className='formLabel' htmlFor="expiry-date-input">
                      Expiry Date
                    </InputLabel>
                    <TextField
                      className="mt10 width100 bgWhite"
                      size="small"
                      type="date"
                      value={
                        formDataIntialise[idx]?.expiryDate ||
                        (ele.complianceValue?.[0] &&
                          getDateFormat(ele.complianceValue?.[0]?.expiryDate, 'onboardingDateFormat')) ||
                        ' '
                      }
                      name="expiryDate"
                      onChange={(event) => handleInput(event, idx)}
                      InputProps={{
                        inputProps: { min: minDate, max: complianceExpiryMaxDate },
                      }}
disabled={
  props?.reupload
    ? false
    : ((ele?.complianceValue?.[0]?.isExpired === true || isSoonToExpire(ele?.complianceValue?.[0]?.expiryDate)) && props.fromSubVendorExpiry) ||
      (ele?.complianceValue?.[0]?.status !== 'Approved' &&
        ele?.complianceValue?.[0]?.status !== 'Uploaded')
      ? false
      : true
}
                    >
                      Expiry Date
                    </TextField>
                  </Grid>
                )}
                {props?.reupload ||
                  ((ele?.complianceValue?.[0]?.isExpired === true || isSoonToExpire(ele?.complianceValue?.[0]?.expiryDate)) && props.fromSubVendorExpiry) ||
                  (ele?.complianceValue?.[0]?.status !== 'Approved' &&
                    ele?.complianceValue?.[0]?.status !== 'Uploaded') ? (
                  <Grid item className="width50" classes='mrb10'>
                    <Button
                      className={`uploadComplianceBtn ${!formValidation?.[ele?.attributeName] && !isInputEmpty(idx, formValidation?.[ele?.attributeName], ele)
                          ? 'buttonSubmit'
                          : 'buttonSubmitDisabled'
                        }`}
                      disabled={isInputEmpty(idx, formValidation?.[ele?.attributeName], ele)}
                      onClick={() =>
                        complainceClick(
                          props?.reupload
                            ? ele?.complianceValue?.[0]?.id
                            : ele?.id,
                          idx
                        )
                      }
                    >
                      {props?.reupload ? 'Reupload' : 'Save'}
                    </Button>
                  </Grid>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </Grid>
        ))}

      </Grid>
    </div>
  );
}
export default ComplianceUpload;